import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import {
  dataGridDateSorter,
  dataGridTextSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { Spinner } from '../../../../common/index.jsx';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';

const SearchHistoryTable = ({ searchHistory }) => {
  const { t } = useTranslation();
  const nameTextFilterProps = useDataGridTextFilter('search_query');
  const dateRangeFilterProps = useDataGridDateRangeFilter('created_at');

  const dataGridColumns = useMemo(
    () => [
      {
        title: t('Vyhľadávaný výraz'),
        dataIndex: 'search_query',
        sorter: dataGridTextSorter('search_query'),
        ...nameTextFilterProps,
      },
      {
        title: t('Dátum a čas'),
        dataIndex: 'created_at',
        sorter: dataGridDateSorter('created_at'),
        render: (date) =>
          (date &&
            new Date(date).toLocaleString().replace(/(.*)\D\d+/, '$1')) ||
          '-',
        ...dateRangeFilterProps,
      },
    ],
    [t, nameTextFilterProps, dateRangeFilterProps],
  );

  if (!searchHistory) {
    return <Spinner />;
  }

  return (
    <>
      <DataGrid
        rowKey={(searchHistory) => searchHistory.id}
        columns={dataGridColumns}
        dataSource={searchHistory || []}
        permissionsBasic={'search-history'}
        uniqueTableId={'search-history-table'}
        disableSettings={true}
      />
    </>
  );
};

export default SearchHistoryTable;
